// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__-gUAY","left":"StickyBox_left__1FIO0","right":"StickyBox_right__1GFRC"};